module.exports = __webpack_public_path__ + "static/media/islavalles3.61b0bb81.JPG";